import api from './base/BaseApi';
import { handleApiError } from './base/handleApiError';
import { TGetCustomerResponse } from './types/Customer';

export const getCustomer = () =>
  api.get<TGetCustomerResponse>('api/v1/customers').catch(handleApiError);
